<template>
  <div class="Town">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "Town"
};
</script>
